import { AnimatePresence, motion } from "framer-motion";

import { Loader } from "@/components/Loader";

interface CreatingUserOverlayProps {
  children: React.ReactNode;
  isPending: boolean;
}

export function CreatingUserOverlay({
  children,
  isPending,
}: CreatingUserOverlayProps) {
  return (
    <div className="relative">
      <AnimatePresence mode="wait">
        {isPending ? (
          <motion.div
            animate={{ opacity: 1, scale: 1 }}
            className="flex min-h-48 flex-col items-center justify-center gap-4 py-12"
            exit={{ opacity: 0, scale: 0.95 }}
            initial={{ opacity: 0, scale: 0.95 }}
            key="loader"
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <Loader className="bg-transparent" />
            <p className="text-base font-medium text-text-secondary">
              Creating user...
            </p>
          </motion.div>
        ) : (
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            initial={{ opacity: 0, y: -8 }}
            key="form"
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
